module.exports = __webpack_public_path__ + "img/JPME_120X35.4bd10a4d.png";